module.exports = require('frontend/components/abstract').extend

  template: require('./index.pug')

  props:
    rootUrl: { default: null }

  computed:

    logoUrl: ->
      require('shared/kunstgegenmauern_50x50.png')

  methods:

    openMenu: ->
      document.getElementsByTagName('body')[0].setAttribute('class', 'comp-navigation-wrapper-open')

    closeMenu: ->
      document.getElementsByTagName('body')[0].setAttribute('class', '')


// WEBPACK FOOTER //
// ./assets/js/frontend/components/navigation_wrapper/index.coffee